<template>
  <div class="content-cont">
    <p class="header-title">
      {{ $t("common.delete") }} {{ $t("common.user") }}
    </p>
    <div class="hint-modal">
      {{ $t("common.notes.areYouSureYouWant") }}
      <b>"{{ $t("common.delete") }}"</b> {{ fullName
      }}{{ $t("common.questionMark") }}
    </div>
    <b-spinner
      v-if="isLoading"
      variant="secondary"
      role="status"
      size="sm"
      class="wizard-spinner"
    />
    <p v-if="siteName && areaName" class="user-signout">
      {{ $t("users.form.signInto") }} "{{ siteName }} - {{ areaName }}"{{
        $t("users.form.willBeSignedOut")
      }}
    </p>
    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns">
      <button
        @click="
          $bvModal.hide('deleteActionModal');
          $bvModal.hide(getModalInfo.modalId);
        "
        class="submit-action-btn btn btn-primary"
        size="md"
        :disabled="getLoading"
      >
        {{ $t("common.cancel") }}
      </button>
      <button
        @click="onSubmit()"
        class="cancel-btn"
        type="button"
        :disabled="getLoading || isLoading"
      >
        {{ $t("common.delete") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DeleteUserAction",
  data() {
    return {
      user_id: null,
      fullName: null,
      isLoading: true,
      siteName: null,
      areaName: null,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("users", ["getModalState", "getLoading"]),
  },
  methods: {
    ...mapActions("users", [
      "deleteUser",
      "resetLoading",
      "fetchLastVisitForUser",
    ]),
    async onSubmit() {
      const { user_id, deleteUser } = this;
      await deleteUser(user_id);
      this.$bvModal.hide("deleteActionModal");
      if (this.getModalInfo.modalId)
        this.$bvModal.hide(this.getModalInfo.modalId);
      this.$emit("changeUserStatusOrDeleted", this.getModalInfo.id);
    },
  },
  beforeMount() {
    // console.log("this.getModalInfo", this.getModalInfo);
    this.fetchLastVisitForUser({
      params: {
        user_id: this.getModalInfo.id,
        entity_id: this.getModalInfo.current_entity.entity_id,
      },
    }).then((data) => {
      // console.log('data', data);
      this.isLoading = false;
      this.siteName = data && data.data ? data.data.site_name : null;
      this.areaName = data && data.data ? data.data.area_name : null;
    });
    this.resetLoading();
  },
  mounted() {
    if (this.getModalInfo) {
      const { id, fullName } = this.getModalInfo;
      this.user_id = id;
      this.fullName = fullName;
    }
  },
};
</script>

<style lang="scss">
div[id*="deleteActionModal"] {
  div[id*="___BV_modal_content_"] {
    width: 580px !important;
    top: 150px;
    inset-inline-start: 50px;
    border-radius: 26px;
  }
  .modal-content .modal-body {
    p.header-title {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      margin-bottom: 40px;
      color: #000000;
    }
    .hint-modal {
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      margin: 0 auto 0px auto;
      text-align: center;
      color: #787878;
    }
    .user-signout {
      font-size: 16px;
      font-weight: 400;
      line-height: 29px;
      letter-spacing: 0.25px;
      text-align: center;
      width: 417px;
      margin: 16px auto 0px auto;
      color: #939393;
    }
    .h-line {
      opacity: 0.15;
      background: #707070;
      width: 488px;
      margin: 40px auto 20px auto;
    }
    .action-btns {
      // margin-bottom:20px;
      .submit-action-btn {
        background: #103f5e;
        border-radius: 16.6275px;
        width: 112px;
        height: 32px;
        color: #ffffff;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        margin-inline-end: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .cancel-btn {
        border: 1.5px solid #f46a6a;
        background: #ffffff;
        border-radius: 16.6275px;
        color: #f46a6a;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        width: 112px;
        height: 32px;
      }
    }
  }
  :disabled {
    cursor: not-allowed;
  }
}
</style>
